import { Injectable, InjectionToken } from '@angular/core';
import * as Rollbar from 'rollbar';

import { environment } from '../../../environments/environment';

const rollbarConfig = {
  accessToken: 'ae172fd155cc4d94ab4788b0af425681',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: environment.production ? 'production' : 'development',
  },
};

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');
